import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

export function selectServiceIds(state: IAppState): Array<EServiceId> {
  return state.publishTerms.serviceIds;
}
